import { LANDSCAPE_LOGO_DATA } from './logos.generated.js';
/**
 * Technology logos for the systems landscape diagrams, keyed by `TechStackSystem.logoKey`.
 *
 * Each value is an image data URI (vendor logos, scripts and external links stripped; sources and usage notes in
 * `logos/SOURCES.md`; regenerate with `node scripts/build-landscape-logos.mjs`). A key with no entry falls back to an initials badge, so the diagram never
 * depends on a logo being present.
 */
export const LANDSCAPE_LOGOS = LANDSCAPE_LOGO_DATA;
/** Logo data URI for a key, or null. */
export function landscapeLogo(key) {
    return (key && LANDSCAPE_LOGOS[key]) || null;
}
/**
 * Two-letter badge text for a product name: the capitals of a CamelCase word ("NetSuite" -> "NS",
 * "HubSpot" -> "HS"), else the first letters of the first two words ("Sage Intacct" -> "SI"),
 * else the first two letters.
 */
export function landscapeInitials(name) {
    const words = name
        .replace(/\(.*?\)/g, ' ')
        .split(/[\s/]+/)
        .map((w) => w.replace(/[^A-Za-z0-9.]/g, ''))
        .filter(Boolean);
    if (words.length === 0)
        return '?';
    const caps = (words[0].match(/[A-Z]/g) ?? []).join('');
    if (words.length === 1 && caps.length >= 2)
        return caps.slice(0, 2);
    if (words.length >= 2)
        return (words[0][0] + words[1][0]).toUpperCase();
    return words[0].slice(0, 2).toUpperCase();
}
//# sourceMappingURL=logos.js.map